import React from 'react';
import { Container, Typography, Button, Grid, Paper, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const HypnoContent = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      
      {/* Introduction Section */}
      <Paper elevation={0} sx={{ p: 4, mb: 4, backgroundColor: '#FFFBFBFF', textAlign: 'start', fontFamily: 'poppins, sans-serif',border:"1px solid",borderColor:"grey.300" }}>
      <Typography variant="h6" component="h2" sx={{ mb: 2, color: '#2E3B55', fontWeight: '600',fontFamily:"poppins" }}>
        With a focus on confidentiality and personalized care, our sessions help clients:
      </Typography>

      {/* Point 1 */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <CheckCircleIcon sx={{ color: '#2E3B55', mr: 2 }} />
        <Typography variant="body1" sx={{ color: '#2E3B55',fontFamily:"poppins" }}>
          Reduce stress, anxiety, and emotional overwhelm.
        </Typography>
      </Box>

      {/* Point 2 */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <CheckCircleIcon sx={{ color: '#2E3B55', mr: 2 }} />
        <Typography variant="body1" sx={{ color: '#2E3B55' ,fontFamily:"poppins" }}>
          Gain insight into unresolved emotions and recurring life patterns.
        </Typography>
      </Box>

      {/* Point 3 */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <CheckCircleIcon sx={{ color: '#2E3B55', mr: 2 }} />
        <Typography variant="body1" sx={{ color: '#2E3B55' ,fontFamily:"poppins" }}>
          Heal from past traumas and uncover new perspectives.
        </Typography>
      </Box>

      {/* Point 4 */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <CheckCircleIcon sx={{ color: '#2E3B55', mr: 2 }} />
        <Typography variant="body1" sx={{ color: '#2E3B55',fontFamily:"poppins"  }}>
          Find clarity, balance, and purpose in life.
        </Typography>
      </Box>

      <Typography variant="body2" sx={{ mt: 2, color: '#2E3B55',fontFamily:"poppins"  }}>
        Each session is tailored to your individual needs, offering a safe and supportive space to achieve personal growth and emotional well-being.
      </Typography>
    </Paper>

      {/* Call to Action Section */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h5" component="h3" sx={{ mb: 2, color: '#2E3B55',fontFamily:"poppins"  }}>
          Take the first step toward healing and transformation.
        </Typography>
        <Button
          variant="contained"
          size="large"
          sx={{ backgroundColor: '#2E3B55',fontFamily:"poppins", textTransform:"none",}}
        >
          📞 Schedule Your Session Today
        </Button>
      </Box>

      {/* Contact Information Section */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <Paper elevation={0} sx={{ p: 2, textAlign: 'center', backgroundColor: '#F5F5F5' ,fontFamily:"poppins" ,border:"1px solid", borderColor:"grey.300",cursor:"pointer"}}>
            <Typography variant="h6" sx={{ mb: 1, color: '#2E3B55' ,fontFamily:"poppins"}}>
              📞 Call Us
            </Typography>
            <Typography variant="body1" sx={{fontFamily:"poppins"}}>[Insert phone number]</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
        <Paper elevation={0} sx={{ p: 2, textAlign: 'center', backgroundColor: '#F5F5F5' ,fontFamily:"poppins" ,border:"1px solid", borderColor:"grey.300",cursor:"pointer"}}>
        <Typography variant="h6" sx={{ mb: 1, color: '#2E3B55' ,fontFamily:"poppins"}}>
              📧 Email Us
            </Typography>
            <Typography variant="body1" sx={{fontFamily:"poppins"}}>[Insert email address]</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
        <Paper elevation={0} sx={{ p: 2, textAlign: 'center', backgroundColor: '#F5F5F5' ,fontFamily:"poppins" ,border:"1px solid", borderColor:"grey.300",cursor:"pointer"}}>
        <Typography variant="h6" sx={{ mb: 1, color: '#2E3B55' ,fontFamily:"poppins"}}>
              📍 Location
            </Typography>
            <Typography variant="body1" sx={{fontFamily:"poppins"}}>[Insert location for in-person sessions]</Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Footer Section */}
      <Typography variant="body2" align="center" sx={{ mt: 4, color: '#2E3B55' ,fontFamily:"poppins" }}>
        🌐 Learn More: [Insert website link]
      </Typography>
    </Container>
  );
};

export default HypnoContent;